import { render, staticRenderFns } from "./uploadType.vue?vue&type=template&id=34639fde"
import script from "./uploadType.vue?vue&type=script&lang=js"
export * from "./uploadType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports